/**
 * DIY consumer helpers. Role 1 = B2C. Role 14 (REVIEW_PAY) stays B2B.
 */
import { ROLE_ID } from '@/constants/roles';

export function isDiyCustomerRole(roleId) {
  return roleId != null && roleId !== '' && String(roleId) === ROLE_ID.CONSUMER;
}

export function channelTypeForRole(roleId) {
  return isDiyCustomerRole(roleId) ? 'B2C' : 'B2B';
}

/** Consumer (1) or Review & Pay (14) use the DIY confirm-payment page. */
export function usesDiyConfirmPayment(roleId) {
  const id = roleId != null ? String(roleId) : '';
  return id === ROLE_ID.CONSUMER || id === ROLE_ID.REVIEW_PAY;
}
